import * as http from './Http'

const SUPER = 'super'

export const _getCompaniesDebitReqs = () => http.get(`${SUPER}/get-debit-reqs`)
export const _updateDebitReqStatus = (id, status) => http.put(`${SUPER}/wallet/${id}/update`, status)

// export const _saveAdmin = data => http.post(`${SUPER}/save-admin`, data)

// export const _list = () => http.get(`${SUPER}/list`)

// export const _delete = id => http.del(`${SUPER}/delete/${id}`)

// export const _show = id => http.get(`${SUPER}/show/${id}`)

// export const _update = (id, admin) => http.put(`${SUPER}/update/${id}`, admin)
// export const _changePassword = (id, data) => http.put(`${SUPER}/change-password/${id}`, data)
